module.exports = __webpack_public_path__ + "img/obs_water_notset.50530860.svg";